import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { VerificationMethod } from '@unitedtraders/utcom-api-sdk';
import { Box, FinalFormInput, Button, Typography, FormContainer } from '@utex/ui-kit';
import { createValidator, required } from '@unitedtraders/validators';
import { Layout } from '../../components/Layout';
import { useConfirmation } from './hooks';
import { Loader } from '../Loader';
import { FormError } from '../FormError';

export interface FormValues {
  code: string;
}

const validate = createValidator<FormValues>({
  code: [required()],
});

export const Confirmation: React.FC = observer(() => {
  const { t } = useTranslation('confirmation');
  const { loading, validateTips, verificationMethod, onSubmit } = useConfirmation();

  if (loading) {
    return <Loader />;
  }

  return (
    <FormContainer<FormValues>
      onSubmit={onSubmit}
      validate={validate}
      validateTips={validateTips}
      render={({ handleSubmit, submitting, submitError }) => (
        <Layout.Form onSubmit={handleSubmit} noValidate>
          <Layout.FormContent>
            <Box display="flex" flexDirection="column">
              <Box marginBottom={20}>
                <Typography.Title level={2}>{t('Confirm withdrawal request')}</Typography.Title>
              </Box>
              <FinalFormInput
                name="code"
                id="code"
                inputMode="numeric"
                type="number"
                mask={Array(10).fill(/\d|\s/)}
                label={
                  verificationMethod === VerificationMethod.EMAIL
                    ? t('Code from email')
                    : t('Code from GA')
                }
                hintPosition="right"
              />
            </Box>
          </Layout.FormContent>
          <FormError>{submitError}</FormError>
          <Layout.FormFooter>
            <Button view="alert" type="submit" isLoading={submitting}>
              {t('Confirm')}
            </Button>
          </Layout.FormFooter>
        </Layout.Form>
      )}
    />
  );
});
